import type { EvidenceSection } from '@api/brokerCases/types';
import { MOCK_BORROWER } from './mockBorrower';
import { useBorrower } from '@queries/btlApplications/useBorrowers';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { getProgressFromSections, mapBorrowerToApplicantOptions } from './helpers';
import { EvidenceList } from '@pages/EvidencePage/components/EvidenceList/EvidenceList';
import { EvidenceProgressCard } from '@pages/EvidencePage/components/EvidenceProgressCard';
import { Typography } from 'antd';
import { TypedFormatMessageFn } from '@app-types/intl';

export interface EvidencePageProps {
  caseId: string;
  sections: EvidenceSection[];
  isCaseTasksLoading: boolean;
  isEmbedded?: boolean;
}

export const EvidencePage = ({ caseId, sections, isCaseTasksLoading, isEmbedded = false }: EvidencePageProps) => {
  const { formatMessage }: { formatMessage: TypedFormatMessageFn } = useIntl();
  const { data: borrower, isLoading } = useBorrower(caseId);

  const individuals = useMemo(() => mapBorrowerToApplicantOptions(borrower ?? MOCK_BORROWER), [borrower]);

  const progress = getProgressFromSections(sections);

  if (isLoading) {
    return <Typography.Text>{formatMessage({ id: 'evidence.page.loading' })}</Typography.Text>;
  }

  return (
    <div className={`w-full flex gap-6 flex-col pb-10 ${isEmbedded ? '' : 'min-h-screen'}`}>
      <EvidenceProgressCard progress={progress} />
      <EvidenceList sections={sections} individuals={individuals} isCaseTasksLoading={isCaseTasksLoading} />
    </div>
  );
};
